class logoCarousel {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => this.load());
	}

	load() {
    const carousels = document.querySelectorAll('.el-is--slider .twz-element-images__items');
    if(!carousels.length > 0) return

    const getHeighestItem = (images) => {
      return Math.max(...images);
    }

    const Flickity = require('flickity');
    carousels.forEach(carousel => {
      let tickerSpeed = 1.25;
      let flickity = null;

      let config = {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25,
        imagesLoaded: true
      }

      if(carousel.closest('.el-is--slider').getAttribute('data-slider') !== 'true') {
        config.prevNextButtons = true
        config.pageDots = true
        config.draggable = true
      }

      const update = () => {
        if (flickity.slides) {
          flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
          flickity.selectedIndex = flickity.dragEndRestingSelect();
          flickity.updateSelectedSlide();
          flickity.settle(flickity.x);
        }
        window.requestAnimationFrame(update);
      };

      flickity = new Flickity(carousel, config);

      flickity.x = 0;

      if(carousel.closest('.el-is--slider').getAttribute('data-slider') == 'true') update();

    })
	}

}

new logoCarousel;
